const state = {
  device: {},
  interface: {},
  plc: {},
  type: {},
  func: {},
  du: {}
}

const mutations = {
  UPDATE_CONFIG (state, payload) {
    if (!state.hasOwnProperty(payload.type)) {
      throw new Error(`Invalid type: '${payload.type}'`)
    }

    state[payload.type] = payload.data
  }
}

const getters = {
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Config.js